import { createContext } from "react";
import type { GetWBEConfigResponse } from "../api/contracts/site-config";

export interface ConfigurationContextType {
  configuration: GetWBEConfigResponse | null;
  identifier: string | undefined;
  isLoading: boolean;
  error: string | null;
}

/**
 * Lives apart from the provider so a reader of the context (the feature-flag hook, used by
 * components the embed widget also bundles) does not pull the provider's module graph in.
 */
export const ConfigurationContext = createContext<
  ConfigurationContextType | undefined
>(undefined);
